import type { ChangeEvent } from "react";
// import config from "../Json/config.json";

// const { mineScoresArray } = config;

export const isValidNumber = (value: string) => {
  const regex = /^\d+(\.\d{0,2})?$/;
  if (/^0\d+/.test(value)) {
    value = value.replace(/^0+/, "");
    if (value === "" || value.startsWith(".")) {
      value = "0" + value;
    }
  }

  if (regex.test(value)) {
    return value;
  } else {
    return value;
  }
};

export const handleChangeNum = (e: ChangeEvent<HTMLInputElement>) => {
  const { value } = e.target;

  if (!isNaN(Number(value))) {
    return value;
  }
};

export const setLocalItem = (key: string, value: string | number): void => {
  localStorage.setItem(key, value.toString());
};

export const getLocalItem = (key: string): string | null => {
  return localStorage.getItem(key);
};

// export const calculateScore = (mines: number, boxesOpened: number) => {
//   const scoreData = mineScoresArray.find((item) => item.mines === mines);
//   if (!scoreData) {
//     return { error: `Invalid mine count: ${mines}` };
//   }

//   if (boxesOpened < 0 || boxesOpened > scoreData.scores.length) {
//     return { error: `Invalid number of boxes opened: ${boxesOpened}` };
//   }

//   // const score =  boxesOpened <=1 ?  scoreData.scores[boxesOpened] :scoreData.scores[boxesOpened - 1];
//   const score = scoreData.scores[boxesOpened];
//   return { score };
// };
